import { ErrorFill16 } from 'ui/icons/aurora/16px/ErrorFill16';
import { colors } from 'ui/theme/colors';
import {
  StyledDataContextDisabledCaption,
  StyledDataContextInnerBody,
  StyledDataContextInnerCountText,
  StyledErrorLoadingWrapper,
  StyledSmallDivider,
} from 'ui/dataContextMenu/DataContextMenu.styled';
import { formatNumberForDisplay } from 'ui/dataContextMenu/utils';
import { DiamondLogo, LogoColors } from 'ui/logo';
import { FieldData, FieldHeader } from './types';

type DataContextFieldProps = {
  fieldDisplayName: string;
  fieldData: FieldData[];
  fieldHeader: FieldHeader;
  isLoading: boolean;
  isError: boolean;
};
export const DataContextField = ({
  fieldDisplayName,
  fieldData,
  fieldHeader,
  isLoading,
  isError,
}: DataContextFieldProps) => {
  const getInnerBody = () => {
    if (isError)
      return (
        <StyledErrorLoadingWrapper data-test={`${fieldDisplayName}_field_error`}>
          <ErrorFill16 />
          Error Loading data
        </StyledErrorLoadingWrapper>
      );
    if (isLoading)
      return (
        <StyledErrorLoadingWrapper data-test={`${fieldDisplayName}_field_loading`}>
          <DiamondLogo color={LogoColors.BLACK} height={16} />
        </StyledErrorLoadingWrapper>
      );
    if (fieldData) {
      return (
        <>
          {fieldData.map((field: FieldData, index) => (
            <div key={field.text}>
              <StyledDataContextInnerBody>
                <div>
                  <StyledDataContextInnerCountText>
                    {formatNumberForDisplay(field.count, 1)}
                  </StyledDataContextInnerCountText>
                  {` ${field.text}`}
                </div>
              </StyledDataContextInnerBody>
              {index < fieldData.length - 1 && <StyledSmallDivider color={colors.grey5} />}
            </div>
          ))}
        </>
      );
    } else {
      return null;
    }
  };

  const InnerBody = getInnerBody();

  return (
    <div data-test={`${fieldDisplayName}_field_data_context`}>
      <StyledDataContextDisabledCaption>
        {fieldHeader.icon}
        {fieldHeader.text}
      </StyledDataContextDisabledCaption>
      {InnerBody}
    </div>
  );
};
